module.exports = __webpack_public_path__ + "img/close.560e89a9.png";